module.exports = __webpack_public_path__ + "img/tubiao5_334_335.1bb63d86.png";